import React from "react";
import { Switch, Route } from "react-router-dom";
import KioskHome from "./Home/KioskHome";
import KioskFacilities from "./Facilities/KioskFacilities";
import KioskShopDetail from "./Shop/KioskShopDetail";
import KioskShop from "./Shop/KioskShop";
import KioskEventDetail from "./Event/KioskEventDetail";
import KioskEvent from "./Event/KioskEvent";
import KioskPromotionDetail from "./Promotion/KioskPromotionDetail";
import KioskPromotion from "./Promotion/KioskPromotion";
import {screenKeys} from "config/constants";
import "./index.css";

function Kiosk(props) {
  return (
      <Switch>
        <Route path={`${props.match.url}/${screenKeys.facilities}`} exact component={KioskFacilities} />
        <Route path={`${props.match.url}/${screenKeys.shop}/:id`} exact component={KioskShopDetail} />
        <Route path={`${props.match.url}/${screenKeys.shop}`} exact component={KioskShop} />
        <Route path={`${props.match.url}/${screenKeys.event}/:id`} exact component={KioskEventDetail} />
        <Route path={`${props.match.url}/${screenKeys.event}`} exact component={KioskEvent} />
        <Route path={`${props.match.url}/${screenKeys.promotion}/:id`} exact component={KioskPromotionDetail} />
        <Route path={`${props.match.url}/${screenKeys.promotion}`} exact component={KioskPromotion} />
        <Route path={`${props.match.url}`} exact component={KioskHome} />
      </Switch>
  );
}
 
export default Kiosk;
